import { Injectable, inject } from '@angular/core';

import { AppInfoConfig, LastKnownProductService, NavigationService, PlatformProductMapConfig } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductResolverService {
    private readonly navigationService = inject(NavigationService);
    private readonly lastKnownProductService = inject(LastKnownProductService);
    private readonly appConfig = inject(AppInfoConfig);
    private readonly platformProductMapConfig = inject(PlatformProductMapConfig);

    async getProduct() {
        const lastKnowProductValue = this.lastKnownProductService.get().name === 'unknown' ? '' : this.lastKnownProductService.get().name;
        await firstValueFrom(this.platformProductMapConfig.whenReady);
        const platformProductValue = this.platformProductMapConfig.platformProductMap?.[lastKnowProductValue];
        const productId =
            this.navigationService.location.search.get('forCashierProductId') ||
            this.navigationService.location.search.get('productId') ||
            platformProductValue ||
            this.appConfig.product;

        return productId.toUpperCase();
    }
}
